export default __webpack_public_path__ + "static/media/lessons_learned.b9d3a968.png";